import {
  Component,
  Host,
  h,
  Prop,
  Element,
  Listen,
  State,
  Event,
  EventEmitter,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-offcanvas-panel',
  styleUrl: 'ui-offcanvas-panel.scss',
  shadow: true,
})
export class UiOffcanvasPanel {
  @Element() el: HTMLUiOffcanvasPanelElement;

  @Prop({ reflect: true, mutable: true }) open: boolean;

  @Prop({ reflect: true }) darken: boolean;

  @Prop() position: 'left' | 'right' = 'left';

  @Prop() activeBelow: number;

  @Prop() closeOutside: boolean;

  @Event() offcanvasTrigger: EventEmitter<{ id: string }>;

  // fallback event used by ui-offcanvas-provider to register this offcanvas panel
  @Event() offcanvasRegister: EventEmitter<{ el: HTMLUiOffcanvasPanelElement }>;

  @State() active: boolean;

  // call provider method registerOffcanvas if provider is directly available
  // fire event offcanvasRegister if provider is not directly available
  public registerInProvider() {
    const offcanvasProviderEl = document.querySelector('ui-offcanvas-provider');

    if (offcanvasProviderEl) {
      offcanvasProviderEl.registerOffcanvas(this.el);
    } else {
      this.offcanvasRegister.emit({ el: this.el });
    }
  }

  componentWillLoad() {
    this.registerInProvider();
    this.onResize();
  }

  onBackgroundClick() {
    if (this.closeOutside) {
      this.offcanvasTrigger.emit({ id: this.el.getAttribute('id') });
    }
  }

  @Listen('resize', { target: 'window' })
  onResize() {
    this.active = !this.activeBelow || window.innerWidth < this.activeBelow;
  }

  render() {
    return (
      <Host class={{ open: this.open, active: this.active }}>
        <div
          class={{
            background: true,
            darken: this.darken,
          }}
          onClick={this.onBackgroundClick.bind(this)}
        ></div>
        <div
          class={{
            slide: true,
            [this.position]: true,
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}

versionComponent(UiOffcanvasPanel);
